<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="form" inline>
					<c-form-item type="input" label="收支流水号" name="record_number"></c-form-item>
					<c-form-item type="select" label="收付渠道" name="record_channel" :options="recordChannel"></c-form-item>
					<c-form-item type="select" label="收支类型" name="record_type" :options="recordType"></c-form-item>
					<c-form-item type="select" label="收付类型" name="turnover_type" :options="turnoverType"></c-form-item>
					<c-form-item type="input" label="收付关联号" name="turnover_number"></c-form-item>
					<c-form-item type="select" label="业务场景" name="business_type" :options="businessType"></c-form-item>
					<c-form-item type="input" label="业务单号" name="business_number"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<c-table-column
					label="账户名称"
					name="account_name"
					width="80"
				>
					<template v-slot="{data}">
						{{account_name}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="收支流水号"
					name="record_number"
					width="80"
				>
				</c-table-column>
				
				<c-table-column
					label="收付渠道"
					name="record_channel"
					width="40"
				>
				</c-table-column>
				
				<c-table-column
					label="收支类型"
					name="record_type"
					width="40"
				>
				</c-table-column>
				
				<c-table-column
					label="业务类型"
					name="turnover_type"
					width="40"
				>
				</c-table-column>
				
				<c-table-column
					label="业务场景"
					name="business_type_zh"
					width="60"
				>
				</c-table-column>

				<c-table-column
					label="业务单号"
					name="business_number"
					width="70"
				>
				</c-table-column>

				<c-table-column
					label="收付关联号"
					name="turnover_number"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="费用类型"
					name="account_title"
					width="50"
				>
				</c-table-column>

				<c-table-column
					label="发生金额"
					name="money"
					width="50"
				>
					<template v-slot="{data}">
						￥{{data.money}}
					</template>
				</c-table-column>

				<c-table-column
					label="账户余额"
					name="surplus_money"
					width="50"
				>
					<template v-slot="{data}">
						￥{{data.surplus_money}}
					</template>
				</c-table-column>

				<c-table-column
					label="待结算金额"
					name="settle_amount"
					width="55"
				>
					<template v-slot="{data}">
						￥{{data.settle_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="摘要"
					name="remark"
				>
				</c-table-column>

				<c-table-column
					label="发生时间"
					name="create_date"
					width="90"
				>
				</c-table-column>

			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'finance_sys_account_record_list',
		
		data() {
			return {
				recordChannel: [{
					name: '请选择',
					value: ''
				},{
					name: '余额',
					value: '余额'
				}, {
					name: '保证金',
					value: '保证金'
				}, {
					name: '待结算',
					value: '待结算'
				}],

				recordType: [
					{
						name: '请选择',
						value: ''
					},{
						name: '收款',
						value: '收款'
					},{
						name: '付款',
						value: '付款'
					}
				],

				turnoverType: [
					{
						name: '请选择',
						value: ''
					},{
						name: '待结算',
						value: '待结算'
					},{
						name: '结算',
						value: '结算'
					},{
						name: '退款',
						value: '退款'
					},{
						name: '提现',
						value: '提现'
					}
				],

				businessType: [],

				disabled: true
			}
		},

		props: {
			id: String,
			account_name: String
		},
		
		mounted() {
			this.getBusinessType();
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				data.account_id = this.id;
				this.$refs.table.load({
					url: '/sys/account/record/list',
					data
				});
			},
			getBusinessType(){
				this.request({
					url: '/sys/account/record/business_type',
					success: data => {
						this.businessType = data;
					}
				});
			},
			exportData(){
				var exportData = this.$refs.form.serialize();
				exportData.job_id = 28;
				exportData.create_system = 'OMS';
				exportData.account_id = this.id;

				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>